import { IssueTypeIdentifierService as OvermapIssueTypeIdentifierService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class IssueTypeIdentifierService extends OvermapIssueTypeIdentifierService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
